module.exports = __webpack_public_path__ + "static/7-206baa0b9a6706c3723c7a3266f3a6ab.jpg";